import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as styles from './recurrence-settings.scss';
import { Recurrence } from './types';

interface RecurrenceUnitLabelProps {
  recurrence: Recurrence;
}

export const RecurrenceUnitLabel = ({ recurrence }: RecurrenceUnitLabelProps) => (
  <div style={{ fontWeight: 400 }} className={styles.labelFont}>
    {recurrence === Recurrence.DAILY ? (
      <FormattedMessage id="common.day_s_no_space" defaultMessage="Day(s)" />
    ) : recurrence === Recurrence.WEEKLY ? (
      <FormattedMessage id="common.week_s_no_space" defaultMessage="Week(s)" />
    ) : recurrence === Recurrence.MONTHLY ? (
      <FormattedMessage id="common.month_s_no_space" defaultMessage="Month(s)" />
    ) : (
      <FormattedMessage id="common.months" defaultMessage="months" />
    )}
  </div>
);
